var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployerIco5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2331_12552)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2331_12552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 3.79418C12.1273 3.68393 12.8115 3.62793 13.5325 3.62793H27.0513C32.688 3.62793 36.041 7.04393 36.041 12.7437L36.041 24.2973C36.041 24.8496 35.5933 25.2973 35.041 25.2973H34.4974C33.9451 25.2973 33.4974 24.8496 33.4974 24.2973V12.7436C33.4974 8.38788 31.3326 6.17763 27.0364 6.17763H13.5334C9.23539 6.17763 7.05664 8.38788 7.05664 12.7436V29.5121C7.05664 33.8679 9.23539 36.0781 13.5334 36.0781H23.9428C24.4951 36.0781 24.9428 36.5258 24.9428 37.0781V37.6279C24.9428 38.1802 24.4951 38.6279 23.9428 38.6279H13.5325C8.48552 38.6279 5.25677 35.8909 4.64602 31.1922C4.57602 30.6567 4.54102 30.0967 4.54102 29.5122V12.7437C4.54102 7.90668 6.95252 4.72868 11.1018 3.86593L11.4833 3.79418Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5797 14.9854C27.2692 14.9854 27.8274 14.4184 27.8274 13.7184C27.8274 13.0184 27.2692 12.4514 26.5797 12.4514H13.9604C13.2709 12.4514 12.7109 13.0184 12.7109 13.7184C12.7109 14.4184 13.2709 14.9854 13.9604 14.9854H26.5797Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7877 21.8105C27.5305 22.2253 27.0597 22.4563 26.5785 22.4038H13.9592C13.3187 22.332 12.834 21.7825 12.834 21.128C12.834 20.4735 13.3187 19.9258 13.9592 19.8523H26.5785C27.0597 19.7998 27.5305 20.0308 27.7877 20.4455C28.045 20.8638 28.045 21.3923 27.7877 21.8105Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7749 29.8047C19.4154 29.7329 19.9002 29.1834 19.9002 28.5289C19.9002 27.8762 19.4154 27.3267 18.7749 27.2549H13.9747C13.3324 27.3267 12.8477 27.8762 12.8477 28.5289C12.8477 29.1834 13.3324 29.7329 13.9747 29.8047H18.7749Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3598 28.7223L31.1106 34.6162L28.945 31.618C28.8219 31.4457 28.625 31.3473 28.4159 31.3473H26.1641C25.8975 31.3473 25.7416 31.6508 25.8975 31.8682L30.5774 38.3569C30.6378 38.4407 30.7173 38.509 30.8093 38.5561C30.9013 38.6032 31.0031 38.6278 31.1065 38.6278C31.2098 38.6278 31.3117 38.6032 31.4037 38.5561C31.4957 38.509 31.5752 38.4407 31.6356 38.3569L38.4032 28.9766C38.559 28.7592 38.4032 28.4557 38.1366 28.4557H35.8848C35.6797 28.4516 35.4828 28.5541 35.3598 28.7223Z",
    fill: "#17B67C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2331_12552",
    x: 0.541016,
    y: 3.62793,
    width: 41.9238,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2331_12552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2331_12552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2331_12552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.503906 0.12793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerIco5);
export default __webpack_public_path__ + "static/media/employer_ico_5.b8fc21ff8aebc3a9e31af3740b814789.svg";
export { ForwardRef as ReactComponent };